module.exports = __webpack_public_path__ + "assets/img/inboxTime.7f1c7271.png";